/**
 * <s-added-suggestions> stays hidden until the product form on the same page
 * reports a successful add to cart, then reveals itself below the form.
 */
class SAddedSuggestions extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    document.addEventListener('s-product-form:added', (event) => {
      const productId = this.dataset.productId;
      if (productId && event.detail?.productId && event.detail.productId !== productId) return;
      this.#reveal();
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #reveal() {
    const wasHidden = this.hidden;
    this.hidden = false;
    const status = this.querySelector('[data-added-status]');
    if (status) {
      status.textContent = '';
      status.textContent = this.dataset.addedMessage || '';
    }
    if (!wasHidden) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
  }
}

if (!customElements.get('s-added-suggestions')) {
  customElements.define('s-added-suggestions', SAddedSuggestions);
}
